// extracted by mini-css-extract-plugin
export default {"containerRes":"ResultDate_containerRes__XE4OV","certo":"ResultDate_certo__5BCH8","errado":"ResultDate_errado__7+JMz"};